/* ==========================================================
   NEWHOMERS PRODUCT GALLERY
   ========================================================== */

if (!customElements.get('nh-product-gallery')) {
  class NHProductGallery extends HTMLElement {
    connectedCallback() {
      this.mainElement = this.querySelector('.js-media-list');
      this.thumbsElement = this.querySelector('.js-media-sublist');
      this.dots = Array.from(this.querySelectorAll('[data-nh-gallery-dot]'));
      this.initialIndex = Math.max(0, Number.parseInt(this.dataset.initialIndex || '0', 10) || 0);
      this.onGalleryClick = (event) => {
        const dot = event.target.closest('[data-nh-gallery-dot]');
        if (!dot || !this.contains(dot) || !this.gallerySwiper) return;
        this.gallerySwiper.slideTo(Number(dot.dataset.nhGalleryDot));
      };
      this.addEventListener('click', this.onGalleryClick);
      this.initializeGallery();
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onGalleryClick);
      window.clearTimeout(this.retryTimer);
      this.gallerySwiper?.off('slideChange', this.syncControls);
      this.thumbsSwiper?.off('click', this.onThumbClick);
      if (this.ownsMainSwiper) this.gallerySwiper?.destroy(true, true);
      if (this.ownsThumbsSwiper) this.thumbsSwiper?.destroy(true, true);
      this.gallerySwiper = null;
      this.thumbsSwiper = null;
    }

    initializeGallery(attempt = 0) {
      if (!this.isConnected || !this.mainElement) return;
      if (typeof window.Swiper !== 'function') {
        if (attempt < 100) {
          this.retryTimer = window.setTimeout(() => this.initializeGallery(attempt + 1), 50);
        }
        return;
      }

      const slides = this.mainElement.querySelectorAll('.swiper-wrapper > .swiper-slide');
      const initialSlide = Math.min(this.initialIndex, slides.length - 1);
      if (initialSlide < 0) return;

      this.thumbsSwiper = this.thumbsElement?.swiper;
      this.ownsThumbsSwiper = false;
      if (this.thumbsElement && !this.thumbsSwiper) {
        this.thumbsSwiper = new window.Swiper(this.thumbsElement, {
          slidesPerView: 3,
          direction: 'horizontal',
          spaceBetween: 8,
          watchSlidesProgress: true,
          breakpoints: {
            990: { direction: 'vertical', slidesPerView: 'auto', spaceBetween: 8 },
          },
        });
        this.ownsThumbsSwiper = true;
      }

      this.gallerySwiper = this.mainElement.swiper;
      this.ownsMainSwiper = false;
      if (!this.gallerySwiper) {
        this.gallerySwiper = new window.Swiper(this.mainElement, {
          slidesPerView: 1,
          initialSlide,
          autoHeight: true,
          spaceBetween: 4,
          observer: true,
          observeParents: true,
          navigation: {
            prevEl: this.querySelector('.nh-gallery__arrow--prev'),
            nextEl: this.querySelector('.nh-gallery__arrow--next'),
          },
          thumbs: { swiper: this.thumbsSwiper || null },
        });
        this.ownsMainSwiper = true;
      } else {
        this.gallerySwiper.slideTo(initialSlide, 0);
      }

      this.syncControls = () => {
        const index = this.gallerySwiper.activeIndex;
        this.dots.forEach((dot, i) => dot.classList.toggle('is-active', i === index));
        this.thumbsSwiper?.slideTo(index);
      };
      this.gallerySwiper.on('slideChange', this.syncControls);
      this.syncControls();

      this.onThumbClick = () => {
        const index = this.thumbsSwiper.clickedIndex;
        if (Number.isInteger(index)) this.gallerySwiper.slideTo(index);
      };
      this.thumbsSwiper?.on('click', this.onThumbClick);

      // Recalculate dimensions after images finish loading.
      this.mainElement.querySelectorAll('img').forEach((img) => {
        if (!img.complete) img.addEventListener('load', () => this.gallerySwiper?.update(), { once: true });
      });
      requestAnimationFrame(() => {
        this.thumbsSwiper?.update();
        this.gallerySwiper?.update();
      });
    }
  }

  customElements.define('nh-product-gallery', NHProductGallery);
}

/* ==========================================================

   NEWHOMERS PRODUCT MODAL

   ========================================================== */



if (

  typeof ModalDialog !== 'undefined' &&

  !customElements.get('nh-product-modal')

) {



  class NHProductModal extends ModalDialog {



    constructor() {



      super();





      this.items =

        Array.from(

          this.querySelectorAll(

            '[data-nh-modal-item]'

          )

        );





      this.counter =

        this.querySelector(

          '[data-nh-modal-counter]'

        );





      this.zoomValue =

        this.querySelector(

          '[data-nh-zoom-value]'

        );





      this.prevButton =

        this.querySelector(

          '[data-nh-modal-prev]'

        );





      this.nextButton =

        this.querySelector(

          '[data-nh-modal-next]'

        );





      this.zoomInButton =

        this.querySelector(

          '[data-nh-zoom-in]'

        );





      this.zoomOutButton =

        this.querySelector(

          '[data-nh-zoom-out]'

        );





      this.currentIndex = 0;





      this.zoomLevels = [

        1,

        1.5,

        2,

        3

      ];





      this.zoomIndex = 0;





      this.baseImageWidth = 0;



      this.baseImageHeight = 0;





      this.bindControls();



      this.bindSwipe();



      this.bindMousePan();



    }







    /* ======================================================

       OPEN

       ====================================================== */



    show(opener) {



      super.show(opener);





      const mediaId =

        opener?.dataset?.mediaId;





      let index =

        this.items.findIndex(

          (item) => {



            return String(

              item.dataset.mediaId

            ) === String(mediaId);



          }

        );





      if (index < 0) {

        index = 0;

      }





      this.showItem(index);



    }







    /* ======================================================

       CLOSE

       ====================================================== */



    hide() {



      this.resetZoom();



      super.hide();



    }







    /* ======================================================

       CONTROLS

       ====================================================== */



    bindControls() {



      if (this.prevButton) {



        this.prevButton.addEventListener(

          'click',

          (event) => {



            event.preventDefault();



            event.stopPropagation();





            this.showItem(

              this.currentIndex - 1

            );



          }

        );



      }





      if (this.nextButton) {



        this.nextButton.addEventListener(

          'click',

          (event) => {



            event.preventDefault();



            event.stopPropagation();





            this.showItem(

              this.currentIndex + 1

            );



          }

        );



      }





      if (this.zoomInButton) {



        this.zoomInButton.addEventListener(

          'click',

          (event) => {



            event.preventDefault();



            event.stopPropagation();





            this.changeZoom(1);



          }

        );



      }





      if (this.zoomOutButton) {



        this.zoomOutButton.addEventListener(

          'click',

          (event) => {



            event.preventDefault();



            event.stopPropagation();





            this.changeZoom(-1);



          }

        );



      }





      this.addEventListener(

        'keydown',

        (event) => {



          /*

           * ESC obsługuje już ModalDialog.

           */





          if (

            event.key === 'ArrowLeft'

          ) {



            event.preventDefault();





            this.showItem(

              this.currentIndex - 1

            );



          }





          if (

            event.key === 'ArrowRight'

          ) {



            event.preventDefault();





            this.showItem(

              this.currentIndex + 1

            );



          }



        }

      );





      this.updateZoomControls();



    }







    /* ======================================================

       IMAGE NAVIGATION

       ====================================================== */



    showItem(index) {



      const total =

        this.items.length;





      if (!total) return;





      if (index < 0) {



        index =

          total - 1;



      }





      if (index >= total) {



        index = 0;



      }





      this.resetZoom();





      this.currentIndex =

        index;





      this.items.forEach(

        (item, itemIndex) => {



          item.hidden =

            itemIndex !== index;



        }

      );





      if (this.counter) {



        this.counter.textContent =

          `${index + 1} / ${total}`;



      }





      const viewport =

        this.getActiveViewport();





      if (viewport) {



        viewport.scrollLeft = 0;



        viewport.scrollTop = 0;



      }



      window.requestAnimationFrame(() => this.applyZoom());



    }







    /* ======================================================

       MOBILE SWIPE



       100%:

       swipe = next/prev image



       zoom > 100%:

       native pan = moving enlarged image

       ====================================================== */



    bindSwipe() {



      this.items.forEach(

        (item) => {



          const viewport =

            item.querySelector(

              '[data-nh-modal-viewport]'

            );





          if (!viewport) return;





          let startX = 0;



          let startY = 0;



          let currentX = 0;



          let currentY = 0;



          let tracking = false;





          viewport.addEventListener(

            'touchstart',

            (event) => {



              if (

                this.zoomIndex > 0 ||

                event.touches.length !== 1

              ) {



                tracking = false;



                return;



              }





              const touch =

                event.touches[0];





              startX =

                touch.clientX;





              startY =

                touch.clientY;





              currentX =

                startX;





              currentY =

                startY;





              tracking = true;



            },

            {

              passive: true

            }

          );





          viewport.addEventListener(

            'touchmove',

            (event) => {



              if (

                !tracking ||

                this.zoomIndex > 0 ||

                event.touches.length !== 1

              ) {



                return;



              }





              const touch =

                event.touches[0];





              currentX =

                touch.clientX;





              currentY =

                touch.clientY;



            },

            {

              passive: true

            }

          );





          viewport.addEventListener(

            'touchend',

            () => {



              if (

                !tracking ||

                this.zoomIndex > 0

              ) {



                tracking = false;



                return;



              }





              tracking = false;





              const deltaX =

                currentX - startX;





              const deltaY =

                currentY - startY;





              /*

               * Gest musi być:

               *

               * - wyraźny,

               * - bardziej poziomy niż pionowy.

               */



              if (

                Math.abs(deltaX) < 45 ||

                Math.abs(deltaX) <

                  Math.abs(deltaY) * 1.25

              ) {



                return;



              }





              if (deltaX < 0) {



                this.showItem(

                  this.currentIndex + 1

                );



              } else {



                this.showItem(

                  this.currentIndex - 1

                );



              }



            },

            {

              passive: true

            }

          );



        }

      );



    }







    /* ======================================================

       MOUSE PAN WHEN ZOOMED

       ====================================================== */



    bindMousePan() {



      this.items.forEach(

        (item) => {



          const viewport =

            item.querySelector(

              '[data-nh-modal-viewport]'

            );





          if (!viewport) return;





          let dragging = false;



          let startX = 0;



          let startY = 0;



          let startScrollLeft = 0;



          let startScrollTop = 0;





          viewport.addEventListener(

            'pointerdown',

            (event) => {



              if (

                this.zoomIndex === 0 ||

                event.pointerType !== 'mouse'

              ) {



                return;



              }





              dragging = true;





              startX =

                event.clientX;





              startY =

                event.clientY;





              startScrollLeft =

                viewport.scrollLeft;





              startScrollTop =

                viewport.scrollTop;





              viewport.classList.add(

                'is-dragging'

              );





              viewport.setPointerCapture?.(

                event.pointerId

              );



            }

          );





          viewport.addEventListener(

            'pointermove',

            (event) => {



              if (!dragging) return;





              const deltaX =

                event.clientX - startX;





              const deltaY =

                event.clientY - startY;





              viewport.scrollLeft =

                startScrollLeft - deltaX;





              viewport.scrollTop =

                startScrollTop - deltaY;



            }

          );





          const stopDragging =

            () => {



              if (!dragging) return;





              dragging = false;





              viewport.classList.remove(

                'is-dragging'

              );



            };





          viewport.addEventListener(

            'pointerup',

            stopDragging

          );





          viewport.addEventListener(

            'pointercancel',

            stopDragging

          );





          viewport.addEventListener(

            'pointerleave',

            stopDragging

          );



        }

      );



    }







    /* ======================================================

       ZOOM

       ====================================================== */



    changeZoom(direction) {



      const nextIndex =

        Math.max(

          0,

          Math.min(

            this.zoomIndex + direction,

            this.zoomLevels.length - 1

          )

        );





      if (

        nextIndex === this.zoomIndex

      ) {



        return;



      }





      this.zoomIndex =

        nextIndex;





      this.applyZoom();



    }







    applyZoom() {



      const item =

        this.items[

          this.currentIndex

        ];





      if (!item) return;





      const viewport =

        item.querySelector(

          '[data-nh-modal-viewport]'

        );





      const canvas =

        item.querySelector(

          '[data-nh-modal-canvas]'

        );





      const image =

        item.querySelector(

          '.nh-product-modal__image'

        );





      if (

        !viewport ||

        !canvas ||

        !image

      ) {



        return;



      }





      const zoom =

        this.zoomLevels[

          this.zoomIndex

        ];





      viewport.classList.toggle(

        'is-zoomed',

        zoom > 1

      );







      /* ====================================================

         100% = FIT TO SCREEN

         ==================================================== */



      if (zoom === 1) {

        image.style.maxWidth = '100%';
        image.style.maxHeight = '100%';

        if (image.complete && image.naturalWidth && image.naturalHeight &&
            viewport.clientWidth && viewport.clientHeight) {
          const fit = Math.min(
            viewport.clientWidth / image.naturalWidth,
            viewport.clientHeight / image.naturalHeight
          );
          this.baseImageWidth = image.naturalWidth * fit;
          this.baseImageHeight = image.naturalHeight * fit;
          image.style.width = `${this.baseImageWidth}px`;
          image.style.height = `${this.baseImageHeight}px`;
        } else {
          image.style.removeProperty('width');
          image.style.removeProperty('height');
          this.baseImageWidth = 0;
          this.baseImageHeight = 0;
          if (!image.complete) {
            image.addEventListener('load', () => this.applyZoom(), { once: true });
          }
        }

        canvas.style.width =

          '100%';





        canvas.style.height =

          '100%';







        viewport.scrollLeft = 0;



        viewport.scrollTop = 0;





        this.updateZoomValue();



        this.updateZoomControls();





        return;



      }







      /* ====================================================

         WAIT UNTIL IMAGE HAS DIMENSIONS

         ==================================================== */



      const rect =

        image.getBoundingClientRect();





      if (

        !rect.width ||

        !rect.height

      ) {



        if (!image.complete) {



          image.addEventListener(

            'load',

            () => {



              this.applyZoom();



            },

            {

              once: true

            }

          );



        }





        return;



      }







      /*

       * Base dimensions are always measured from

       * the fit-to-screen 100% state.

       */



      if (

        !this.baseImageWidth ||

        !this.baseImageHeight

      ) {



        this.baseImageWidth =

          rect.width;





        this.baseImageHeight =

          rect.height;



      }







      const zoomedWidth =

        this.baseImageWidth * zoom;





      const zoomedHeight =

        this.baseImageHeight * zoom;







      image.style.maxWidth =

        'none';





      image.style.maxHeight =

        'none';





      image.style.width =

        `${zoomedWidth}px`;





      image.style.height =

        `${zoomedHeight}px`;







      /*

       * Canvas cannot be smaller than viewport.

       *

       * Thanks to this, image remains centered

       * and overflow appears only when needed.

       */



      canvas.style.width =

        `${Math.max(

          viewport.clientWidth,

          zoomedWidth

        )}px`;





      canvas.style.height =

        `${Math.max(

          viewport.clientHeight,

          zoomedHeight

        )}px`;







      /*

       * Center viewport after zooming.

       */



      window.requestAnimationFrame(

        () => {



          viewport.scrollLeft =

            Math.max(

              0,

              (

                viewport.scrollWidth -

                viewport.clientWidth

              ) / 2

            );





          viewport.scrollTop =

            Math.max(

              0,

              (

                viewport.scrollHeight -

                viewport.clientHeight

              ) / 2

            );



        }

      );





      this.updateZoomValue();



      this.updateZoomControls();



    }







    /* ======================================================

       RESET ZOOM

       ====================================================== */



    resetZoom() {



      this.zoomIndex = 0;





      this.baseImageWidth = 0;



      this.baseImageHeight = 0;





      this.items.forEach(

        (item) => {



          const viewport =

            item.querySelector(

              '[data-nh-modal-viewport]'

            );





          const canvas =

            item.querySelector(

              '[data-nh-modal-canvas]'

            );





          const image =

            item.querySelector(

              '.nh-product-modal__image'

            );





          if (viewport) {



            viewport.classList.remove(

              'is-zoomed'

            );





            viewport.classList.remove(

              'is-dragging'

            );





            viewport.scrollLeft = 0;



            viewport.scrollTop = 0;



          }





          if (canvas) {



            canvas.style.width =

              '100%';





            canvas.style.height =

              '100%';



          }





          if (image) {



            image.style.removeProperty(

              'width'

            );





            image.style.removeProperty(

              'height'

            );





            image.style.maxWidth =

              '100%';





            image.style.maxHeight =

              '100%';



          }



        }

      );





      this.updateZoomValue();



      this.updateZoomControls();



    }







    /* ======================================================

       ZOOM UI

       ====================================================== */



    updateZoomValue() {



      if (!this.zoomValue) return;





      const zoom =

        this.zoomLevels[

          this.zoomIndex

        ];





      this.zoomValue.textContent =

        `${Math.round(

          zoom * 100

        )}%`;



    }





    updateZoomControls() {



      if (this.zoomOutButton) {



        this.zoomOutButton.disabled =

          this.zoomIndex === 0;



      }





      if (this.zoomInButton) {



        this.zoomInButton.disabled =

          this.zoomIndex ===

          this.zoomLevels.length - 1;



      }



    }







    /* ======================================================

       ACTIVE VIEWPORT

       ====================================================== */



    getActiveViewport() {



      return this.items[

        this.currentIndex

      ]?.querySelector(

        '[data-nh-modal-viewport]'

      );



    }



  }





  customElements.define(

    'nh-product-modal',

    NHProductModal

  );



}
